import { createContext } from 'react'
import type { ModulePermissionTypeMap } from '../../types/rbac'

/**
 * @param hasPermission - A function that checks if a user has a permission for a given module and permission type
 * @param permissions - A map of modules and their permission types
 */
export interface PermissionsContextType {
  hasPermission: (module: string, permissionType: string) => boolean
  permissions: ModulePermissionTypeMap
}

export const defaultPermissionsContext: PermissionsContextType = {
  hasPermission: () => false,
  permissions: {},
}

/**
 * Lives in its own module, not beside `PermissionsProvider`: exporting a context
 * from a file that also exports components breaks Fast Refresh's ability to
 * preserve state (react-doctor/only-export-components).
 *
 * App code should use `usePermissions`, never this directly. It is exported so
 * tests can nest it with a fixed map - `PermissionsProvider` fetches, so a test
 * cannot control what it yields, and `mock.module` on a shared hook leaks
 * process-globally (CLAUDE.md failure mode 1). Same seam as FeatureFlagsContext.
 */
export const PermissionsContext = createContext<PermissionsContextType>(defaultPermissionsContext)
